(function ($) {
  // Document Ready
  $(document).ready(function () {
    /***************************************************
      Artist Navigation Handlers
    /*****************************************************/
    const $navContainer = $(".artist-single-navigation");

    if ($navContainer.length) {
      const $navItems = $navContainer.find(".artist-single-nav__item");
      let hasValidLink = false;

      $(window).on("load", function () {
        setTimeout(function () {
          if ($navContainer.css("display") != "none") {
            $("body").addClass("artist-single-navigation-active");
          }
        }, 500);
      });

      // Hide individual nav items if their target sections don't exist
      $navItems.each(function () {
        const $item = $(this);
        const $link = $item.find(".artist-single-nav__link");
        const travelType = $link.data("travel-type");
        const scrollTarget = $link.data("scroll-target");

        // External/virtual links are always valid (non-jump types)
        if (travelType && travelType !== "jump") {
          hasValidLink = true;
          return; // Continue to next item
        }

        // Jump links require their target section to exist
        if (!travelType || travelType === "jump") {
          if (scrollTarget && $(scrollTarget).length) {
            hasValidLink = true;
          } else {
            // Hide the nav item if its scroll target doesn't exist
            $item.hide();
          }
        }
      });

      // If no valid links remain, hide the entire navigation and stop execution
      if (!hasValidLink) {
        $navContainer.hide();
        return;
      }

      console.log("artist-navigation.js initiated");

      const scrollToTarget = (selector) => {
        if (!selector) return;
        const $target = $(selector).first();
        if ($target.length === 0) return;
        const offsetTop = $target.offset().top;
        window.scrollTo({ top: offsetTop, behavior: "smooth" });
      };

      // Active section detection using IntersectionObserver
      const initActiveNavigation = () => {
        const $navLinks = $(".artist-single-nav__link");
        const sectionsMap = new Map();

        // Build map of sections to nav links
        $navLinks.each(function () {
          const $link = $(this);
          const scrollTarget = $link.data("scroll-target");

          if (!scrollTarget) return;

          const $section = $(scrollTarget).first();
          if ($section.length > 0) {
            sectionsMap.set($section[0], $link);
          }
        });

        if (sectionsMap.size === 0) return;

        // IntersectionObserver options
        const observerOptions = {
          root: null,
          rootMargin: "-20% 0px -20% 0px", // Only consider active when 20% into viewport
          threshold: 0.1,
        };

        // Create observer
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const $link = sectionsMap.get(entry.target);
            if (!$link) return;

            if (entry.isIntersecting) {
              // Remove active from all links first
              $navLinks.removeClass("active");
              // Add active to current section
              $link.addClass("active");
            } else {
              // Remove active class when section leaves viewport
              $link.removeClass("active");
            }
          });
        }, observerOptions);

        // Observe all sections
        sectionsMap.forEach((link, section) => {
          observer.observe(section);
        });
      };

      // Initialize active navigation
      initActiveNavigation();

      $(document).on("click", ".artist-single-nav__link", function (e) {
        const $link = $(this);
        const travelType = $link.data("travel-type");
        const scrollTarget = $link.data("scroll-target");

        // Handle jump-type (class-based scroll)
        if (!travelType || travelType === "jump") {
          e.preventDefault();
          if (scrollTarget) {
            scrollToTarget(scrollTarget);
          }
          return;
        }

        // For virtual and external, allow default navigation
      });
    }
  });
})(jQuery);
